import * as React from 'react';
import { observer } from 'mobx-react';

import { FeedItemContainer } from './FeedItemContainer';
import { FeedItemContent } from './FeedItemContent';
import {InlineQuiz} from "components/quiz/InlineQuiz";
import {TableChart} from "components/chart/TableChart";

interface IFeedItemQuizProps {
  feedItem:any;
  updateFeedItem:(feedItem:any, skipUpdatingPoints?:boolean)=>void;
}

@observer
export class FeedItemQuiz extends React.Component<IFeedItemQuizProps> {
  render() {
    var icon = (this.props.feedItem.icon ? this.props.feedItem.icon : (this.props.feedItem._post.icon?this.props.feedItem._post.icon:"icon-clipboard"));
    var title = this.props.feedItem._post.title;	
    var points = (this.props.feedItem._post.pointValue?<div className="text">{this.props.feedItem._post.pointValue} pts.</div>:"")

    // Is this an active Quiz
    if(this.props.feedItem.step<this.props.feedItem._post.steps.length) {
      return (
        <FeedItemContainer read={this.props.feedItem.read} completed={this.props.feedItem.completed} collapsable={false} collapsed={false} extraClassName="inlineQuiz">
          <span className="solution" aria-hidden={true}><i className={icon}/>{points}</span>
          <FeedItemContent title={title} unread={!this.props.feedItem.read}>
            <InlineQuiz feedItem={this.props.feedItem} updateFeedItem={this.props.updateFeedItem}  />
          </FeedItemContent>
        </FeedItemContainer>
      );

    // Is this a chart as a result of a quiz
    } else if(this.props.feedItem._post.isChartable) {
      // table chart of only the answers provided to this quiz that loads another graph
      return (
        <FeedItemContainer read={this.props.feedItem.read} completed={this.props.feedItem.completed} collapsable={false} collapsed={false} extraClassName="inlineChart">
          <span className="solution"><i className={icon}/>{points}</span>
          <FeedItemContent title={this.props.feedItem._post.title} unread={!this.props.feedItem.read}>
            <TableChart feedItem={this.props.feedItem} />
          </FeedItemContent>
          <div>
              {this.props.feedItem.pointsAwarded?<div className="points"><div>+</div><div><div className="circ"><div>{this.props.feedItem.pointsAwarded}</div></div></div></div>:""}							
          </div>
        </FeedItemContainer>
      );

      // traditional chart inline
      // return (
      // 	<FeedItemContainer read={this.props.feedItem.read} completed={this.props.feedItem.completed} collapsable={false} collapsed={false}>
      // 		<LineChartV1 feedItem={this.props.feedItem} />
      // 	</FeedItemContainer>
      // );


    } else {
      return (
        <FeedItemContainer read={this.props.feedItem.read} completed={this.props.feedItem.completed} collapsable={false} collapsed={false} extraClassName="inlineQuiz">
          <span className="solution"><i className={icon}/>{points}</span>
          <div>					
              <FeedItemContent title={title} unread={!this.props.feedItem.read}>
                <div className="text" dangerouslySetInnerHTML={{__html: this.props.feedItem._post.content}}></div>						
              </FeedItemContent>
          </div>
          <div>
              {this.props.feedItem.pointsAwarded?<div className="points"><div>+</div><div><div className="circ"><div>{this.props.feedItem.pointsAwarded}</div></div></div></div>:""}							
          </div>
        </FeedItemContainer>			
      );
    }
  }

}

